import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Download } from 'lucide-react';
import { Typewriter } from 'react-simple-typewriter';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero section">
      <div className="container">
        <div className="hero-grid">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <motion.div 
              className="hero-badge glass-panel hover-target"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.3, duration: 0.5 }}
            >
              <span className="pulse-dot"></span> Available for new opportunities
            </motion.div>
            
            <motion.h1 
              className="hero-title"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              Hi, I'm Prasad.<br />
              <span className="text-gradient-accent typewriter-wrapper">
                <Typewriter
                  words={['Fullstack Engineer.', 'UI/UX Enthusiast.', 'Creative Developer.']}
                  loop={true}
                  cursor
                  cursorStyle='_'
                  typeSpeed={70}
                  deleteSpeed={50}
                  delaySpeed={1500}
                />
              </span>
            </motion.h1>
            
            <motion.p 
              className="hero-description"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8, duration: 1 }}
            >
              A Lead Developer crafting ultra-premium web applications that scale. I bridge the gap between design and robust architecture.
            </motion.p>
            
            <motion.div 
              className="hero-actions"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1, duration: 0.5 }}
            >
              <a href="#projects" className="btn btn-primary hover-target">
                Explore Work <ArrowRight size={18} />
              </a>
              <a href="#contact" className="btn btn-secondary hover-target">
                Contact Me <Download size={18} />
              </a>
            </motion.div>
          </motion.div>

          <motion.div 
            className="hero-visuals"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.6, duration: 1 }}
          >
            <div className="profile-container glass-panel">
              <div className="profile-image-wrapper">
                <img src="/profile.jpg" alt="Prasad Nallajala" className="profile-image" onError={(e) => { e.target.style.display = 'none'; }} />
              </div>
              <div className="floating-badge badge-1 glass-panel">
                <span className="badge-icon">⚡</span>
                <span>Fast</span>
              </div>
              <div className="floating-badge badge-2 glass-panel">
                <span className="badge-icon">✨</span>
                <span>Premium UI</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
